module.exports = __webpack_public_path__ + "static/media/visuel03.7ba3d0e0.jpg";